<dp-breadcrumb [breadCrumb]="breadCrumb"></dp-breadcrumb>

<div class="row m-0 mb-3">
    <app-sinclair-cards class="p-0" [cards]="sinclairCards" (filterChanged)="loadAllComponents()"
        (filtersClicked)="cardFiltersClicked($event)"></app-sinclair-cards>
</div>
<div class="row m-0 pb-3">
    <app-monitoring-chart class="p-0" [dgeId]="dgeId"> </app-monitoring-chart>
</div>
<div class="row m-0 pb-3">
    <div class="col-12 px-0">
        <app-monitoring-header (filtersChanged)="onFilterChange($event)" [dgeId]="dgeId">
        </app-monitoring-header>

        <app-monitoring-table (tableLoaded)="onTableLoaded($event)" [dgeId]="dgeId" [filters]="filters"
            class="col-12">
        </app-monitoring-table>
    </div>
</div>
